/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { ISOs } from 'utils/form/constants';

export const messageIdMap = {
  [ISOs.ATA]: 'antarctica',
  [ISOs.AUT]: 'austria',
  [ISOs.CAN]: 'canada',
  [ISOs.CHE]: 'switzerland',
  [ISOs.CZE]: 'czechRepublic',
  [ISOs.DEU]: 'germany',
  [ISOs.ESP]: 'spain',
  [ISOs.FRA]: 'france',
  [ISOs.GBR]: 'unitedKingdom',
  [ISOs.IDN]: 'indonesia',
  [ISOs.JPN]: 'japan',
  [ISOs.KOR]: 'southKorea',
  [ISOs.MYS]: 'malaysia',
  [ISOs.NLD]: 'netherlands',
  [ISOs.NZL]: 'newZealand',
  [ISOs.POL]: 'poland',
  [ISOs.PRT]: 'portugal',
  [ISOs.ROU]: 'romania',
  [ISOs.SGP]: 'singapore',
  [ISOs.THA]: 'thailand',
  [ISOs.TWN]: 'taiwan',
  [ISOs.USA]: 'unitedStates',
  [ISOs.ZAF]: 'southAfrica',
} as const;

export const countriesList: ISOs[] = [
  ISOs.ATA,
  ISOs.AUT,
  ISOs.CAN,
  ISOs.CHE,
  ISOs.CZE,
  ISOs.DEU,
  ISOs.ESP,
  ISOs.FRA,
  ISOs.GBR,
  ISOs.IDN,
  ISOs.JPN,
  ISOs.KOR,
  ISOs.MYS,
  ISOs.NLD,
  ISOs.NZL,
  ISOs.POL,
  ISOs.PRT,
  ISOs.ROU,
  ISOs.SGP,
  ISOs.THA,
  ISOs.TWN,
  ISOs.USA,
  ISOs.ZAF,
];
